export const mobileTableViewportClass =
  'max-sm:max-w-full max-sm:overflow-x-auto max-sm:overflow-y-visible max-sm:overscroll-x-contain max-sm:[-webkit-overflow-scrolling:touch]';

export const mobileTableClass =
  'max-sm:!w-full max-sm:!table-fixed max-sm:min-w-[720px] max-sm:[&_thead_th]:sticky max-sm:[&_thead_th]:top-0 max-sm:[&_thead_th]:z-20 max-sm:[&_thead_th]:bg-white max-sm:[&_thead_th]:whitespace-nowrap max-sm:[&_th]:px-3 max-sm:[&_td]:px-3 max-sm:[&_th]:py-2 max-sm:[&_td]:py-2 max-sm:[&_th]:text-xs max-sm:[&_td]:text-xs';

export const mobileActionGroupClass =
  'max-sm:w-full max-sm:flex-col max-sm:items-stretch max-sm:gap-1.5';

export const mobileActionButtonClass = 'max-sm:w-full max-sm:justify-center';

export const mobilePaginationShellClass = 'max-sm:flex-col max-sm:items-stretch max-sm:gap-3';

export const mobilePaginationInfoClass =
  'max-sm:w-full max-sm:flex-col max-sm:items-stretch max-sm:justify-start max-sm:gap-2 max-sm:whitespace-normal';

export const mobilePaginationButtonsClass = 'max-sm:w-full max-sm:justify-center max-sm:gap-2';

export const mobilePaginationButtonClass =
  'inline-flex items-center justify-center gap-1 max-sm:min-w-[72px] max-sm:px-3 max-sm:py-1.5 max-sm:text-xs';

export const mobilePaginationCurrentClass = 'max-sm:text-xs max-sm:whitespace-nowrap';

export const mobilePaginationArrowClass = 'sm:hidden';

export const mobilePaginationAntdWrapperClass = 'sm:hidden flex w-full justify-center';
